require('./bootstrap')

import 'array-flat-polyfill'
import { createApp, h } from 'vue'
import { createInertiaApp, Link, router } from '@inertiajs/vue3'
import AppHead from '@/Shared/AppHead'
import JetButton from '@/Jetstream/Button'
import MenuLink from '@/Shared/MenuLink'
import Card from '@/Shared/Card'
import Email from '@/Shared/Email'
import Phone from '@/Shared/Phone'
import DateTimeText from '@/Shared/DateTimeText'
import FlashMessages from '@/Shared/FlashMessages'
import PrimeVue from 'primevue/config'
import DataTable from 'primevue/datatable'
import Paginator from 'primevue/paginator'
import Column from 'primevue/column'
import globalMethods from './globalMethods'
import VueCardFormat from '@/VueCreditCardValidation/index.js'
import ConfirmationService from 'primevue/confirmationservice'
import VueGtag from 'vue-gtag'
import VueGoogleMaps from '@fawmi/vue-google-maps'
import * as Sentry from "@sentry/vue";
import VueBrowserDetect from "@/plugins/browserDetect";

const app = createInertiaApp({
    id: 'app',
    title: title => title || `Mobile Tool Network`,
    resolve: name => require(`./Pages/${name}`).default,
    setup({ el, App, props, plugin }) {
        createApp({
            render: () =>
                h(App, Object.assign(props, {
                    initialPage: JSON.parse(el.dataset.page),
                    resolveComponent: (name) => require(`./Pages/${name}`).default,
                })),
            })
            .mixin({
                methods: globalMethods,
                data() {
                    return {
                      query: new URLSearchParams(window.location.search),
                      notSupported: this.$browserDetect.isFirefox,
                    }
                },
            })
            .use(VueGtag, {
                config: { id: window.GA }
            })
            .use(plugin)
            .use(PrimeVue)
            .use(ConfirmationService)
            .use(VueCardFormat)
            .use(VueBrowserDetect)
            .use(VueGoogleMaps, {
                load: {
                    key: window.GMaps,
                    libraries: "places"
                }
            })
            .component('inertia-link', Link)
            .component('router-link', MenuLink)
            .component('AppHead', AppHead)
            .component('DataTable', DataTable)
            .component('Paginator', Paginator)
            .component('Column', Column)
            .component('Email', Email)
            .component('DateTimeText', DateTimeText)
            .component('Phone', Phone)
            .component('jet-button', JetButton)
            .component('card', Card)
            .component('flash-messages', FlashMessages)
            .mount(document.getElementById('app'));
    },
    progress: {
        color: '#00FFcc',
        delay: 1500,
        showSpinner: true,
        includeCSS: true,
      },
})

Sentry.init({
    dsn: window.SENTRY_DSN,
    environment: window.ENV,
    release: window.SENTRY_RELEASE,
    tracesSampleRate: window.SENTRY_TRACES_SAMPLE_RATE,
  });

router.on('navigate', (event) => {
    if (app?.$page?.props?.auth?.user) {
        app.$gtag.config({ user_id: app.$page.props.auth.user.id });
    }

    app?.$gtag?.pageview({
        page_path: event.detail.page.url,
    });
});
